import { HStack, Spinner } from 'native-base'
import React from 'react'
import type { ISpinnerProps } from 'native-base/src/components/primitives/Spinner/types'

type Props = {
  size?: ISpinnerProps['size']
}
const LoadingSpinner: React.FC<Props> = (props) => {
  // const size = props.size || 'sm'
  return (
    <HStack
      space={2}
      justifyContent="center"
      position={'absolute'}
      alignContent="center"
      padding={5}
      left={0}
      right={0}
      height={'100%'}
    >
      <Spinner accessibilityLabel="Betöltés" size={props.size} />
    </HStack>
  )
}

const LOADING_LOAD_OPACITY = 0.3
export { LoadingSpinner, LOADING_LOAD_OPACITY }
